export default () => ({
  formats: [],
});
